"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from "react";
import { useInView } from "@/hooks/useInView";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { useOptimizedVideo } from "@/hooks/useOptimizedVideo";
import { useHlsPlayer } from "@/hooks/useHlsPlayer";
interface Props {
  readonly src: string;
  readonly disableAutoPlay?: boolean | undefined;
}
function DropListItemContentMediaVideo(t0) {
  const $ = _c(21);
  const {
    src,
    disableAutoPlay: t1
  } = t0;
  const disableAutoPlay = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      threshold: 0.1
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [wrapperRef, inView] = useInView(t2);
  const {
    isApp
  } = useDeviceInfo();
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      pollInterval: 10000,
      maxRetries: 8,
      preferHls: true,
      exponentialBackoff: false
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    playableUrl,
    isHls
  } = useOptimizedVideo(src, t3);
  const t4 = inView && !isApp && !disableAutoPlay;
  let t5;
  if ($[2] !== isHls || $[3] !== playableUrl || $[4] !== src || $[5] !== t4) {
    t5 = {
      src: playableUrl,
      isHls,
      fallbackSrc: src,
      autoPlay: t4
    };
    $[2] = isHls;
    $[3] = playableUrl;
    $[4] = src;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const {
    videoRef,
    isLoading
  } = useHlsPlayer(t5);
  const shouldAutoPlay = inView && !isApp && !disableAutoPlay;
  let t6;
  let t7;
  if ($[7] !== isApp || $[8] !== isLoading || $[9] !== shouldAutoPlay || $[10] !== videoRef) {
    t6 = () => {
      const videoEl = videoRef.current;
      if (!videoEl || isLoading) {
        return;
      }
      if (shouldAutoPlay) {
        videoEl.muted = true;
        if (!isApp) {
          videoEl.play().catch(_temp);
        }
      } else {
        videoEl.pause();
        videoEl.muted = true;
      }
    };
    t7 = [shouldAutoPlay, isApp, isLoading, videoRef];
    $[7] = isApp;
    $[8] = isLoading;
    $[9] = shouldAutoPlay;
    $[10] = videoRef;
    $[11] = t6;
    $[12] = t7;
  } else {
    t6 = $[11];
    t7 = $[12];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[13] !== videoRef) {
    t8 = () => {
      const videoEl_0 = videoRef.current;
      if (!videoEl_0) {
        return;
      }
      videoEl_0.setAttribute("webkit-playsinline", "true");
      videoEl_0.setAttribute("x5-playsinline", "true");
    };
    t9 = [videoRef];
    $[13] = videoRef;
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  useEffect(t8, t9);
  let t10;
  if ($[16] !== videoRef) {
    t10 = <video ref={videoRef} playsInline={true} controls={true} autoPlay={false} muted={true} loop={true} className="tw-h-full tw-w-full tw-rounded-xl tw-object-contain">Your browser does not support the video tag.</video>;
    $[16] = videoRef;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== wrapperRef) {
    t11 = <div ref={wrapperRef} className="tw-group tw-relative tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center">{t10}</div>;
    $[18] = t10;
    $[19] = wrapperRef;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}
function _temp() {}
export default React.memo(DropListItemContentMediaVideo);